import { HELP_URL, WELCOME_URL } from "../../routes/constants";

export const shouldDisabledLink = (route, userInfo, subscription) => {
  return (
    route !== WELCOME_URL &&
    route !== HELP_URL &&
    (userInfo.isBlocked || !subscription || !subscription.isValid)
  );
};
